import { Navigate } from "react-router-dom";

export default function RoleRedirect() {
  const storedUser = localStorage.getItem("user");

  let user = null;
  try {
    user = storedUser ? JSON.parse(storedUser) : null;
  } catch (error) {
    console.error("Error parsing user:", error);
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Normaliza el rol por si llega como role | typeUser | type | rol
  const rawRole = user.role ?? user.typeUser ?? user.type ?? user.rol ?? null;
  const role = rawRole ? String(rawRole).trim().toUpperCase() : null;

  switch (role) {
    case "ADMIN":
      return <Navigate to="/admin" replace />;
    case "SUPERVISOR":
      return <Navigate to="/home" replace />;
    case "OPERATOR":
      return <Navigate to="/operator" replace />;
    default:
      return <Navigate to="/home" replace />;
  }
}
